module.exports = __webpack_public_path__ + "img/dome2.1ff49858.jpg";